import { NavLink } from "react-router";

const Home = () => {
  return (
    <div>
      <h1>Not found</h1>

      <NavLink to="/" end>
        Home
      </NavLink>
    </div>
  );
};

export default Home;
